module.exports = __webpack_public_path__ + "static/media/banner-clients-07-mobile.73127c2f.jpg";